import React from "react";
import { useSelector } from "react-redux";
import { selectInputArguments } from "../../../store/slices/projectSlice";
import Input from "../../nodes/Logic/Inputs/Input";
import InputArgumentField from "../sidebar/ProjectStartForm/InputArgumentField";

export default function VisibilityInputs({
  editedVariable,
  setEditedVariable,
  inputArguments: _inputArguments = null,
}) {
  const inputArguments = _inputArguments || useSelector(selectInputArguments);
  const selectedVariable = inputArguments.find(
    (vg) => vg.Field === editedVariable?.VisibilityField
  );

  return (
    <>
      <h5 className="mt-5">Conditional Visibility </h5>
      <div className="text-secondary">
        Show and validate field/tab if specific field matches condition
      </div>
      <div className="mb-3">
        <label className="form-label">Check field</label>
        <Input
          key={inputArguments.map((ia) => ia.Field).join("|")}
          inputType="select"
          isValidNewOption={() => false}
          isClearable
          options={inputArguments
            .filter((ia) => ia.Field && ia.UUID !== editedVariable?.UUID)
            .filter(
              (ia) =>
                ia.Format === "number" ||
                (ia.Format === "short-text" && ia.IsSelect) ||
                (ia.Format === "configuration" &&
                  ia.DataStructure === "Buttons") ||
                (ia.Format === "configuration" &&
                  ia.DataStructure === "Yes / No")
            )
            .map((ia) => ({
              value: ia.Field,
              label: ia.Label,
            }))}
          value={[editedVariable?.VisibilityField ?? ""]}
          onChange={(values) =>
            setEditedVariable({
              ...editedVariable,
              VisibilityField: values[0],
              VisibilityValues: [],
              VisibilityLogical: "",
            })
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Operator</label>
        <Input
          inputType="select"
          isClearable
          isValidNewOption={() => false}
          options={[
            { value: "is", label: "Equals" },
            { value: "is_not", label: "Not equals" },
            ...(selectedVariable?.Format === "number"
              ? [
                  { value: "gte", label: "Greater than" },
                  { value: "lte", label: "Less than" },
                ]
              : []),
          ]}
          value={[editedVariable?.VisibilityLogical ?? ""]}
          onChange={(values) =>
            setEditedVariable({
              ...editedVariable,
              VisibilityLogical: values[0],
            })
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Value</label>
        <InputArgumentField
          arg={selectedVariable || {}}
          values={editedVariable?.VisibilityValues ?? []}
          onChange={(newValues) =>
            setEditedVariable({
              ...editedVariable,
              VisibilityValues: newValues,
            })
          }
          inputArgumentsInEditor={[]}
        />
      </div>
    </>
  );
}
